import React from "react";
import { DeleteButton, ShowButton, TopToolbar, usePermissions } from "react-admin";
import PropTypes from "prop-types";
import { ROLES } from "../constants";

EditActions.propTypes = {
  noDel: PropTypes.bool,
};

function EditActions({ basePath, data, resource, noDel = false }) {
  //  
  const { permissions } = usePermissions();

  return (
    <TopToolbar>
      <ShowButton basePath={basePath} record={data} />
      {permissions?.includes( ROLES.SUPER_ADMIN) && <DeleteButton basePath={basePath} record={data} resource={resource} />}
      {/* Add your custom actions */}
    </TopToolbar>
  );
}

export default EditActions;
